import { SVGProps } from "react";

export const ReturnIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="28"
    height="25"
    viewBox="0 0 28 25"
    fill="none"
    {...props}
  >
    <path
      d="M6.66653 2.10583L2 6.10584L6.66653 10.7725"
      stroke="currentColor"
      strokeWidth="2.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2 6.10583H17.3292C21.9179 6.10583 25.8147 9.85277 25.9936 14.4392C26.1826 19.2856 22.1781 23.4392 17.3292 23.4392H5.99893"
      stroke="currentColor"
      strokeWidth="2.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
